import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AddressFields from './AddressFields';
import DefaultButton from 'components/Utils/NewDefaultButton';
import PerformanceUtils from 'services/PerformanceUtils';
import { api } from 'careand-redux/api/ApiThunks';
import { useAppDispatch } from 'careand-redux/useAppDispatch';

const EditAddress = (props) => {
  const user = props.patient || props.physician;

  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState(user.address || {});

  function onAddressChange(event) {
    setAddress({
      ...address,
      [event.target.name]: event.target.value,
    });
  }

  async function onSubmit(event) {
    event.preventDefault();
    if (addressChanged()) {
      let modifiedUser = { ...user, address };
      setLoading(true);

      const options = {
        errorTitle: 'Address',
      };

      let result;

      if (props.patient)
        result = await dispatch(
          api.Patients.updatePatient({ id: modifiedUser.id, patient: modifiedUser }),
          options,
        );
      if (props.physician)
        result = await dispatch(
          api.Physicians.updatePhysician({
            id: modifiedUser.id,
            physician: modifiedUser,
          }),
          options,
        );

      setLoading(false);

      if (result && props.onSuccess) props.onSuccess(result.address);
    }
  }

  function addressChanged() {
    return !PerformanceUtils.isEqual(address, user.address);
  }

  return (
    <form className="row" onSubmit={onSubmit}>
      <AddressFields
        showNotes={!!props.physician}
        address={address}
        onChange={onAddressChange}
        onSearchResult={setAddress}
      />
      <DefaultButton
        name="Save Address"
        className="padded"
        disabled={!addressChanged()}
        loading={loading}
      />
    </form>
  );
};

EditAddress.propTypes = {
  patient: PropTypes.object,
  physician: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default EditAddress;
